import { useEffect, useState } from "react";
export default function useAllowShowTooltip() {
    var _a = useState(false), allowTooltip = _a[0], setAllowTooltip = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            setAllowTooltip(true);
        }, 500);
        return function () { return clearTimeout(timer); };
    }, []);
    return allowTooltip;
}
